import { render, staticRenderFns } from "./BuscaProfissionais.vue?vue&type=template&id=bafe34b0&scoped=true"
import script from "./BuscaProfissionais.vue?vue&type=script&lang=js"
export * from "./BuscaProfissionais.vue?vue&type=script&lang=js"
import style0 from "./BuscaProfissionais.vue?vue&type=style&index=0&id=bafe34b0&prod&lang=css"
import style1 from "./BuscaProfissionais.vue?vue&type=style&index=1&id=bafe34b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafe34b0",
  null
  
)

export default component.exports